// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"ad5647ba","110":"c908b55f","368":"328141ff","440":"25daf3fc","472":"f3ff5c38"}[chunkId] + ".chunk.css";
};